import React from "react"

const LinearGradient: React.FC<React.PropsWithChildren<any>> = ({ children, style }) => (
  <div style={style}>{children}</div>
)

export default LinearGradient
